import Link from 'next/link';
import { useUnit } from 'effector-react';

import { getAllCategoriesQuery } from '@/shared/api/catalog/api';
import { ProductCard } from '@/shared/components/product-card';
import { Title } from '@/shared/components/ui/title';
import { Wrapper } from '@/shared/components/wrapper';

export const CatalogMain = () => {
  const { data: categories } = useUnit(getAllCategoriesQuery);

  return (
    <Wrapper>
      <Title type="h2" className="mt-5 lg:mt-10">
        Каталог
      </Title>

      <h1 className="sr-only">Каталог</h1>

      <p className="text-gray-500 lg:text-[30px]">{categories?.data.length || 0} разделов</p>

      <div className="my-5 h-[1px] w-full bg-primary-foreground opacity-70 lg:my-10" />

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {categories?.data.map((category) => (
          <Link href={`/catalog/${category.attributes.slug}`} key={category.id} className="flex h-full">
            <ProductCard
              title={category.attributes.name}
              image={`${process.env.NEXT_PUBLIC_API_ENDPOINT}${category.attributes.image.data.attributes.formats.medium.url}`}
              className="flex-grow"
              noDialog
            />
          </Link>
        ))}
      </div>
    </Wrapper>
  );
};
